var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11.997 8.81932C11.6391 8.81932 11.3322 8.70107 11.0766 8.46456C10.8209 8.22805 10.693 7.94361 10.693 7.61122C10.693 7.27884 10.8209 6.99439 11.0766 6.75788C11.3322 6.52138 11.6391 6.40313 11.997 6.40313C12.3582 6.40313 12.665 6.52138 12.9175 6.75788C13.1731 6.99439 13.301 7.27884 13.301 7.61122C13.301 7.94361 13.1731 8.22805 12.9175 8.46456C12.665 8.70107 12.3582 8.81932 11.997 8.81932ZM10.6739 16.95V10.0864H13.3202V16.95H10.6739Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.90629689f185fdc277f6848ce069103b.svg";
export { ForwardRef as ReactComponent };